import React from "react";

function ContactPage(props){
    return(
        <p>Contact Page</p>
    );
}

export default ContactPage;